var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      attrs: { id: "login-modal" },
      on: {
        click: function ($event) {
          _vm.show = false
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "login-box",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submitContact.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "login-label" }, [
                _vm._v(_vm._s(_vm.$t("contact.label"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "social-link cell centered" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.phone_number,
                      expression: "phone_number",
                    },
                  ],
                  staticClass: "form-input form-input-phone-number",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("contact.phonePlaceholder"),
                  },
                  domProps: { value: _vm.phone_number },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.phone_number = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "learn-more-description" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("contact.description")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "contact-button", attrs: { type: "submit" } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("contact.submitButton")) +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }